// extracted by mini-css-extract-plugin
module.exports = {"articlePreview":"ArticlePreview--articlePreview--35pn8","link":"ArticlePreview--link--2wGP4","title":"ArticlePreview--title--1xpEX"};